module.exports = __webpack_public_path__ + "img/89.70088dce.png";